import { bool, func, number } from 'prop-types';
import React from 'react';
import { MdFilter1 } from 'react-icons/md';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

class MarkPrimaryButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();

    const { id, opportunityId, loading, onRequest, onSuccess } = this.props;

    if (!loading) {
      onRequest({
        id: opportunityId,
        data: { primaryQuoteId: id },
      })
        .then(() => onSuccess(id))
        .catch(console.error); // eslint-disable-line no-console
    }
  }

  render() {
    const { id, currentPrimary, opportunityId, disabled } = this.props;

    if (!opportunityId || id === currentPrimary) {
      return <MdFilter1 />;
    }

    const buttonId = `make-${id}-primary-quote-of-${opportunityId}`;
    return (
      <>
        <input
          type="checkbox"
          id={buttonId}
          onClick={this.handleClick}
          disabled={disabled}
        />
        <Tooltip target={buttonId}>Make this the primary quote</Tooltip>
      </>
    );
  }
}

MarkPrimaryButton.propTypes = {
  id: number.isRequired,
  currentPrimary: number,
  opportunityId: number,

  onSuccess: func.isRequired,
  disabled: bool.isRequired,

  loading: bool.isRequired,
  onRequest: func.isRequired,
};

MarkPrimaryButton.defaultProps = {
  currentPrimary: undefined,
  opportunityId: undefined,
};

export default withApiRequest({
  query: api.patchOpportunity,
  error: 'flash',
})(MarkPrimaryButton);
